<template>
  <ContainerComponent>
    <div class="main">
      <div class="content">
        <div class="header">
          <div class="title">
            <p>ERS Portfolio</p>
          </div>
        </div>
        <div class="container">
          <div class="body">
            <div class="image-container">
              <img
                ref="wall"
                alt="wall"
                class="showcase"
                src="../assets/images/portfolio.png"
              />
            </div>
            <div ref="showcaseFooter" class="bottom-escape">
              <div class="bottom-inner">
                <i
                  class="icon icon-arrow-left text-xl clickable"
                  @click="goBack($event)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ContainerComponent>
</template>

<script>
import ContainerComponent from '@/components/ContainerComponent';

export default {
  components: {
    ContainerComponent
  },
  props: {},
  data() {
    return {
      activeTab: 0
    };
  },
  methods: {
    activateTab(index) {
      this.activeTab = index;
    },
    goBack() {
      this.$router.go(-1);
    },
    sortLooper(from, to) {
      var arr = [];
      /* Does not include end of array (the "to" value) */
      this.sections.slice(from, to).forEach(val => {
        arr.push(val);
      });
      return arr;
    }
    // productRouter(e) {
    //   var section = e.currentTarget.getAttribte("data-section");
    // }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '../assets/common.less';

.main {
  display: flex;
  flex: 1;
  background-color: @layer1;
  .content {
    margin: @space-base @space-large @space-large @space-large;
    display: flex;
    flex: 1;
    flex-direction: column;

    .header {
      display: flex;
      flex-direction: row;
      .title p {
        margin: @space-xl @space-xl @space-xl (@space-xxl + @space-xl);
        font-size: @font-size-3xl;
        line-height: 1.5em;
        font-weight: 400;
      }
    }
  }

  .container {
    display: flex;
    flex: 1;
    flex-direction: column;
    .header {
      display: flex;
      justify-content: space-between;
      h1 {
        margin: @space-base @space-xl;
      }
      .labels {
        margin: @space-base @space-large;
        span {
          margin: 0 @space-small;
          font-size: @label-font-size;
          padding: 0 0 2px 0;
        }
        .capacity {
          border-bottom: 2px solid @orange-50;
        }
        .compact {
          border-bottom: 2px solid @green-35;
        }
        .coverage {
          border-bottom: 2px solid @blue-43;
        }
      }
    }
    .body {
      display: flex;
      flex: 1;
      .image-container {
        position: absolute;
        top: @appbar-height;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        flex: 1;
        justify-content: center;
        .showcase {
          display: flex;
          object-fit: contain;
          max-width: 100%;
          height: 95vh;
        }
      }
      .bottom-escape {
        position: fixed;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding-left: @space-xl;
        padding-right: @space-xl;
        padding-bottom: @space-large;
      }
    }
  }
}
</style>
